import React from 'react'
import { connect } from 'react-redux'
import Panel from './Panel'
import LeftNav from 'material-ui/Drawer'

export default (o) => (
	(o.opened)?
		<LeftNav open={!!o.opened} width={(o.width)? o.width : 600} openRight={true} style={{zIndex: 1000, overflow: 'hidden'}}>
			<Panel
				deleteFunction={o.deleteFunction}
				type={o.opened.type}
				data={o.data}
				id={o.opened.id}
				showPrompt={false}
				deleteProjectFunction={o.deleteProjectFunction}
				triggerPrompt={() => false}
				openAttachment={o.openAttachment}
				openPanel={o.openPanel}
				new={o.opened.new}
				closePanel={o.closePanel}
				updateFunction={o.updateFunction}
				style={o.style}
				history={o.history}
				deleteLeaseFunction={o.deleteLeaseFunction}
			/>
		</LeftNav>
	: <div></div>
)



// WEBPACK FOOTER //
// ./src/components/RightPanel/index.js